module.exports = __webpack_public_path__ + "assets/adpoly-facility-stores-bulk-upload-template.8c38d4f5.xlsx";